import HistoryList from "./HistoryList";
import Sheet from "./Sheet";

/**
 * Match-Verlauf als Sheet. aktionen: siehe HistoryList (nur Host).
 * @category spiel
 */
export function HistoryModal({ eintraege, leerText, aktionen, namen, onClose }) {
  return (
    <Sheet titel="Verlauf" mitX onClose={onClose}>
      <HistoryList eintraege={eintraege} leerText={leerText} aktionen={aktionen} namen={namen} />
    </Sheet>
  );
}

export default HistoryModal;
